import script from "./NavItem.vue?vue&type=script&lang=ts"
export * from "./NavItem.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__